import { render, staticRenderFns } from "./NewItem.vue?vue&type=template&id=13c109ea&scoped=true&"
import script from "./NewItem.vue?vue&type=script&lang=js&"
export * from "./NewItem.vue?vue&type=script&lang=js&"
import style0 from "./NewItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewItem.vue?vue&type=style&index=1&id=13c109ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c109ea",
  null
  
)

export default component.exports